import { FC } from "react";
import {
  grayPointSVG,
  greenServiceSVG,
  trashSVG,
} from "../../../assets/SVGs/SVGs";
import { useDispatch, useSelector } from "react-redux";
import { selectedService } from "../../../types/service";
import {
  setPackages,
  setServices,
  setStartTime,
} from "../../../services/store/slices/cart";
import { useQuery } from "@tanstack/react-query";
import { clientGetAvailableTimeSlots } from "../../../network/clientSide";
import { Button, Spin } from "antd";
import { formateTimeToAMPM } from "../../../utils/DateUtils";
import { selectedPackages } from "../../../types/package";
import PackagesSVG from "../../../assets/catalog/PackagesSVG";
import { useIntl } from "react-intl";

interface ServicesTimeSlotsProps {}
const ServicesTimeSlots: FC<ServicesTimeSlotsProps> = ({}) => {
  const intl = useIntl();
  const { currentLang, services, packages, start_time, location, date, token } =
    useSelector(
      (state: {
        cart: {
          services: {
            services: selectedService[];
            packages: selectedPackages[];
            date: Date | null;
            start_time: string | null;
          };
          location: { id: number | null };
          client: {
            // phoneNumber:  string | null,
            // phoneCountryCode:  string | null,
            token: string | null;
          };
        };
        user: {
          currentLang: "en" | "ar";
        };
      }) => {
        return {
          services: state.cart.services.services,
          packages: state.cart.services.packages,
          location: state.cart.location,
          date: state.cart.services.date,
          token: state.cart.client.token,
          start_time: state.cart.services.start_time,
          currentLang: state.user.currentLang,
        };
      }
    );
  const { data: timeSlots, isLoading } = useQuery(
    [
      "availableTimeSLots",
      date,
      location?.id,
      services[0]?.teamMember?.id,
      ...services?.map((item: { id: Number }) => item?.id),
      ...packages?.map((item: { id: Number }) => item?.id),
    ],
    () =>
      clientGetAvailableTimeSlots(location?.id, token, {
        date,
        pricing_option_ids: services?.map((item: { id: Number }) => item?.id),
        team_member_id:
          services[0]?.teamMember?.id || packages[0]?.teamMember?.id,
        package_ids: packages?.map((item: { id: Number }) => item?.id),
      }),
    {
      enabled: !!token && !!date,
      select: (res) => res?.data?.data,
    }
  );

  const dispatch = useDispatch();
  const handleRemoveService = (id: number) => {
    const newServices = services?.filter((service) => service.id !== id);
    dispatch(setServices(newServices));
  };
  const handleRemovePackage = (id: number) => {
    const newPackages = packages?.filter((service) => service.id !== id);
    dispatch(setPackages(newPackages));
  };
  return (
    <div className="shadow p-6 space-y-4 rounded-lg  max-h-[100vh] ">
      <div className="space-y-4">
        <h4 className="text-salon-primary text-xl ">
          {intl.formatMessage({ id: "pickAppointmentTime" })}
        </h4>
        <p className="text-color-sec-title">
          {intl.formatMessage({ id: "pickAppointmentTimeDesc" })}
        </p>
      </div>

      <div className="space-y-3">
        {services?.length ? (
          <div>
            <p className="text-salon-primary">
              {intl.formatMessage({ id: "selectedServices" })}
            </p>

            <div className="max-h-[60vh] overflow-auto space-y-1">
              {services.map((service, i) => (
                <div className=" bg-[#FDFDFF] px-2 rounded flex justify-between items-center gap-1 text-color-primary">
                  <p className="flex gap-2 items-center">
                    <span>{greenServiceSVG}</span>
                    <span>{service.name}</span>
                  </p>
                  <span>{grayPointSVG}</span>
                  <p className="flex gap-2 items-center">
                    <span>{service.duration}</span>
                    <small className="text-xs">
                      {intl.formatMessage({ id: "mins" })}
                    </small>
                  </p>
                  <span>{grayPointSVG}</span>
                  <p className="flex gap-2 items-center">
                    <span>{service.price}</span>
                    <small className="text-xs">
                      {intl.formatMessage({ id: "SAR" })}
                    </small>
                  </p>
                  <Button
                    type="link"
                    htmlType="button"
                    onClick={() => handleRemoveService(service.id)}
                  >
                    {trashSVG}
                  </Button>
                </div>
              ))}
            </div>
          </div>
        ) : null}
        {packages?.length ? (
          <div>
            <p className="text-salon-primary">
              {intl.formatMessage({ id: "selectedPackages" })}
            </p>

            <div className="max-h-[60vh] overflow-auto space-y-1">
              {packages.map((pkg, i) => (
                <div className=" bg-[#FDFDFF] px-2 rounded flex justify-between items-center gap-1 text-color-primary">
                  <p className="flex gap-2 items-center">
                    <PackagesSVG />
                    <span>{pkg?.name}</span>
                  </p>
                  <span>{grayPointSVG}</span>
                  <p className="flex gap-2 items-center">
                    <span>{pkg?.total_time}</span>
                    <small className="text-xs">
                      {intl.formatMessage({ id: "mins" })}
                    </small>
                  </p>
                  <span>{grayPointSVG}</span>
                  <p className="flex gap-2 items-center">
                    <span>{pkg.retail_price}</span>
                    <small className="text-xs">
                      {intl.formatMessage({ id: "SAR" })}
                    </small>
                  </p>
                  <Button
                    type="link"
                    htmlType="button"
                    onClick={() => handleRemovePackage(pkg.id)}
                  >
                    {trashSVG}
                  </Button>
                </div>
              ))}
            </div>
          </div>
        ) : null}
        {isLoading ? (
          <div className="flex justify-center">
            <Spin size="large" />
          </div>
        ) : (
          <div className="space-y-3">
            <p className="text-salon-primary font-semibold ">
              {intl.formatMessage({ id: "pickTheAppropriateTimeFrom" })}:
            </p>
            <div className="flex flex-wrap gap-2 overflow-auto">
              {timeSlots?.map(
                (
                  time: { start_time: string; finish_time: string },
                  index: number
                ) => (
                  <Button
                    key={index}
                    htmlType="button"
                    type={
                      time?.start_time === start_time ? "primary" : "default"
                    }
                    className={
                      time?.start_time !== start_time
                        ? "text-color-sec-title text-sm"
                        : " text-sm"
                    }
                    onClick={() => {
                      dispatch(setStartTime(time?.start_time));
                    }}
                  >
                    {formateTimeToAMPM(time.start_time, currentLang)} -{" "}
                    {formateTimeToAMPM(time.finish_time, currentLang)}
                  </Button>
                )
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ServicesTimeSlots;
